module.exports = __webpack_public_path__ + "img/affiliate.fb94c8b0.webp";